export type InstallEvent=Event&{prompt:()=>Promise<void>;userChoice:Promise<{outcome:"accepted"|"dismissed"}>};
let deferred:InstallEvent|null=null;
export function listenForInstall(){addEventListener("beforeinstallprompt",event=>{event.preventDefault();deferred=event as InstallEvent;dispatchEvent(new Event("arabom:install-ready"))})}
export function isInstalled(){return matchMedia("(display-mode: standalone)").matches||(navigator as Navigator&{standalone?:boolean}).standalone===true}
export async function promptInstall():Promise<"accepted"|"dismissed"|"ios_sheet"|"manual">{
 if(/iPhone|iPad|iPod/u.test(navigator.userAgent))return "ios_sheet";
 if(!deferred)return "manual";await deferred.prompt();const {outcome}=await deferred.userChoice;deferred=null;return outcome;
}
